import '../styles/index.scss';
// libs
//-------------------------------------------------------
window.$ = require('jquery');

window.jQuery = window.$;

require('./libs/index');

// utils
//----------------------------------------------
require('./utils/index');

// components
import APP from './components/app/index';

window.Frontend = { APP };
APP.init();

require('./components/nav/index');
require('./components/airport-today/airport-today');
require('./components/sliders/news-slider');
require('./components/sliders/share-slider');
require('./components/sliders/alerts-slider');
require('./components/sliders/article-slider');
require('./components/sliders/history-slider');
require('./components/way/way');
require('./components/vip-terminal/vip-terminal');
require('./components/animations/index');
require('./components/select/index');
require('./components/datepicker/index');
require('./components/scroll-to-collapse/index');
require('./components/sticky-search/index');
require('./components/show-by-step/index');
require('./components/map-parking/index');
require('./components/parking-tabs/index');
//----------------------------------------------



// WEBPACK FOOTER //
// ./src/scripts/index.js